import { useStyles } from './AddStageInfo1.styles';

export default function AddStageInfo1() {
  const classes = useStyles();

  return (
    <>
      <div className={classes.numberCircleInline}>
        <div className={classes.numbersInCirclesInline}>1</div>
      </div>
      <div className={classes.textInline}>Dane osobowe</div>
      <hr className={classes.line}></hr>
      <div className={classes.numberCircleOutline}>
        <div className={classes.numbersInCirclesOutline}>2</div>
      </div>
      <div className={classes.textOutline}>Dane organizacyjne</div>
    </>
  );
}
